import { GLServiceBase, ServiceRoute } from "@/commonui/services";
import { LanguageSkillModel, VCSLevelModel, TagModel, DeleteContentParamsModel } from "@/models/title-list-model";

class TitleListServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcs" };

	constructor() {
		super();
		this.getTitleTextList = this.getTitleTextList.bind(this);
	}

	getLevels(licenseTypes?: number[], includeDisabled: boolean = false): Promise<VCSLevelModel[]> {
		return this.get("Levels", { licenseTypes: licenseTypes, includeDisabled: includeDisabled });
	}

	getLanguageSkills(): Promise<LanguageSkillModel[]> {
		return this.get("LanguageSkills");
	}

	getTags(): Promise<TagModel[]> {
		return this.get("tags");
	}

	getTitleTextList(params?: any) {
		return this.request.get(this.url("GetTitleListText"), params);
	}

	deleteTextFromList(params: DeleteContentParamsModel) {
		return this.request.post(this.url("deleteContent"), params);
	}
}

export const TitleListService = new TitleListServiceClass();
